import { Injectable } from '@angular/core';

@Injectable()
export class EmailBase {
    constructor() { }
    emailBody = ' ';
    emailSubject = ' ';
    emailToMailList: string[];
}
